const GAME_SESSION_NAMESPACE = "game-session";
const SET_BETS_PLACED = "SET_BETS_PLACED";
const SET_BET_WINS = "SET_BET_WINS";
const SET_SESSION_START = "SET_SESSION_START";
const SET_GAME_SESSION = "SET_GAME_SESSION";

export { GAME_SESSION_NAMESPACE, SET_BETS_PLACED, SET_BET_WINS, SET_GAME_SESSION, SET_SESSION_START };
